const vehicleCarCompany = localStorage.getItem('vehicleCarCompany')
const vehicleCarBrand = localStorage.getItem('vehicleCarBrand')
export const GetListCarBrands = (carCompany: string) => {
  let obj = [
    {
      value: '0',
      label: 'Chọn hiệu xe',
    },
  ]
  if (vehicleCarCompany && vehicleCarBrand) {
    let listVehicleCarCompanies = JSON.parse(vehicleCarCompany)
    let listVehicleCarBrands = JSON.parse(vehicleCarBrand)

    let checkCarCompany = listVehicleCarCompanies.find((o: any) => o.value == carCompany)
    if (checkCarCompany) {
      let carBrand = listVehicleCarBrands.filter((o: any) => o.parent == checkCarCompany.id)
      if (carBrand) {
        carBrand.forEach((o: any) => {
          let data = {
            value: o.value,
            label: o.label,
          }
          obj.push(data)
        })
      }
    }
  }
  return obj
}
